import React from 'react';
import MusicPermissionToUseBulkEditPopup from './MusicPermissionToUseBulkEditPopup';
import MusicPermissionToUseEditPopup from './MusicPermissionToUseEditPopup';
import MusicPermissionToUseListPopup from './MusicPermissionToUseListPopup';
import { MusicEntity } from '../../types/MusicEntityTypes';

export default function MusicPermissionToUsePopupSequence({
  music,
  initialDefaultPermissionToUse,
  onClose,
  onEdit,
  onBulkEdit,
} : {
  music: MusicEntity,
  initialDefaultPermissionToUse: number,
  onClose: () => void,
  onEdit: () => void,
  onBulkEdit: (bulkPermissionToUse: number) => void,
}) {
  const [popup, setPopup] = React.useState('edit');

  return (
    <>
      {popup === 'edit' && (
        <MusicPermissionToUseEditPopup
          music={music}
          onDone={() => onEdit()}
          onCancel={() => onClose()}
          onPresentPermissionToUseList={() => setPopup('list')}
          onBeginPermissionToUseBulkEdit={() => setPopup('bulkEdit')}
        />
      )}
      {popup === 'bulkEdit' && (
        <MusicPermissionToUseBulkEditPopup
          initialDefaultPermissionToUse={initialDefaultPermissionToUse}
          onDone={(newDefaultPermissionToUse) => onBulkEdit(newDefaultPermissionToUse)}
          onCancel={() => onClose()}
        />
      )}
      {popup === 'list' && (
        <MusicPermissionToUseListPopup
          onClose={() => setPopup('edit')}
        />
      )}
    </>
  );
}
